import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UsersService } from '../../shared/services/users.service';
import { ChangeRequestConstants } from '../change-request.constants';
import { ChangeRequestItem } from '../models/change-request-item';
import { ChangeRequestItemService } from '../services/change-request-item.service';
import { retry, switchMap, timer } from 'rxjs';

@Component({
  selector: 'app-change-request-item',
  templateUrl: './change-request-item.component.html',
  styleUrls: ['./change-request-item.component.scss']
})
export class ChangeRequestItemComponent implements OnInit {

  @Output() isCreateChangeRequestItemSliderActive = new EventEmitter<boolean>();
  @Input() isCreateChangeRequestItemSliderOpen: boolean = false;
  @Input() documentNumber!: string;
  @Input() documentVersion!: string;
  @Input() documenteQMSScopes!: number[];
  @Output() setDocumentDetailsLoader = new EventEmitter<boolean>();
  changeRequestItemForm!: FormGroup;
  additionalNotifiedUsersOptions: any[] = [];
  valueField: string = 'value';
  labelField: string = 'name';
  errorMessages: string[] = [];
  changeRequestItem!: ChangeRequestItem;
  mandatoryFields:any;
  userList:any[] = [];
  changeRequestItemId!: string;
  changeRequestItemSliderLoader: boolean = false;
  

  constructor(private formBuilder: FormBuilder,
    private changeRequestItemService:ChangeRequestItemService, 
    private messageService:MessageService, 
    private confirmationService:ConfirmationService, 
    private usersService:UsersService,
    private router:Router) { }

  ngOnInit(): void {
    this.loadUsers();
    this.changeRequestItemForm = this.createFormGroupWithBuilderAndModel();
    this.setDefaults();
    this.mandatoryFields = this.mandatoryFieldsError();
  }

  createFormGroupWithBuilderAndModel() {
    return this.formBuilder.group({
      description: new FormControl('', [Validators.required]),
      benefitOfChange: new FormControl(),
      changeDue: new FormControl('', [Validators.required]),
      additionalNotifiedUsers: new FormControl(),
    })
  }

  loadUsers(){
    this.userList = [];
    this.usersService.getUsersForCRI(this.documenteQMSScopes).subscribe(
      (usersData: any) => {
        for (var dataItem of usersData) {
          this.userList.push({
            value: dataItem.name,
            name: dataItem.name
          })
        }
      }
    );
  }

  setDefaults(){
    this.changeRequestItemForm.controls['changeDue'].setValue(1);
  }

  createChangeRequestItem() {
    this.setDataBeforeSave();
    this.validateChangeRequestItem();
    if(this.errorMessages.length == 0){
     this.changeRequestItemSliderLoader = true;  
      this.setDocumentDetailsLoader.emit(true);
      this.changeRequestItemService.createChangeRequestItem(this.changeRequestItem)
      .pipe(
        switchMap((changeRequestItem) =>
        {
          this.changeRequestItemSliderLoader = true; 
          this.changeRequestItemId = changeRequestItem.id;
          return this.changeRequestItemService.getChangeRequestItemById(this.changeRequestItemId)
          .pipe(
            retry({
              count: 5,
              delay: (error, retryCount) => {
                if (retryCount >= 5) {
                  this.changeRequestItemSliderLoader = false; 
                  this.messageService.add({
                    severity: ChangeRequestConstants.Severity_Error,
                    summary: ChangeRequestConstants.ChangeRequestItem_Creation_Failed,
                    sticky: true
                  });
                  throw error;
                }
                return timer(3000); // wait 3 seconds before retrying
              }
            })
          );
        })
      )
      .subscribe((response)=>{
        this.closeAndResetChangeRequestItemSlider(); 
        this.messageService.add({
          severity: ChangeRequestConstants.Severity_Info,
          summary: String(ChangeRequestConstants.ChangeRequestItemSave).replace("{0}",response.changeRequestItemNumber)
        });
      // To do -- Need to check for better solution to avoid timeout
      setTimeout(() => {
        this.setDocumentDetailsLoader.emit(false);
      }, 2000);
      })
        
    }
  }

  setDataBeforeSave() {
    let formValues = this.changeRequestItemForm.getRawValue();
    this.changeRequestItem = {
      description : formValues.description,
      benefitOfChange : formValues.benefitOfChange,
      changeDue : formValues.changeDue,
      additionalNotifiedUsers : formValues.additionalNotifiedUsers,
      documentNumber : this.documentNumber,
      documentVersion : this.documentVersion
    };
  }

  validateChangeRequestItem(){
      this.errorMessages = [];
      this.mandatoryFields = this.mandatoryFieldsError();
      if (this.changeRequestItemForm.invalid) {
        Object.keys(this.changeRequestItemForm.controls).forEach(key => {
          if (this.changeRequestItemForm.get(key)?.errors) {
            let errorText = this.getErrorMessageText(key);
            this.errorMessages.push(errorText);
          }
        });
      }
  }

  getErrorMessageText(key:string){
    let errorText = "";
    if(key == 'description'){
      errorText = ChangeRequestConstants.DescriptionRequiredErrorMessage;
      this.mandatoryFields.description = true;
    }
    if(key == 'changeDue'){
      errorText = ChangeRequestConstants.DescriptionRequiredErrorMessage;
      this.mandatoryFields.changeDue = true;
    }
    return errorText;
  }

  confirm() {
    this.confirmationService.confirm({
      message: ChangeRequestConstants.ChangeRequestItemConfirmationMessage,
      header: ChangeRequestConstants.ChangeRequestItemConfirmationHeader,
      icon: "pi pi-exclamation-triangle",
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeAndResetChangeRequestItemSlider();
      }
    });
  }

  closeAndResetChangeRequestItemSlider() {
    this.isCreateChangeRequestItemSliderOpen = false;
    this.isCreateChangeRequestItemSliderActive.emit(this.isCreateChangeRequestItemSliderOpen);
    this.changeRequestItemForm.reset();
    this.setDefaults();
    this.errorMessages = [];
    this.mandatoryFields = this.mandatoryFieldsError();
  }

  private mandatoryFieldsError() {
    return {
      description: false,
      changeDue: false,
    };
  }
}
